import { workerFetch } from '../../net/network-client';

export class GaupaChallengeError extends Error {
  status: number;

  constructor(message: string, { status }: { status: number }) {
    super(message);
    this.name = 'GaupaChallengeError';
    this.status = status;
  }
}

/** Browser → Gaupa: exchange domain JWT for a challenge (never sent to Smash API). */
export async function fetchGaupaChallenge(gaupaHost: string, publicKey: string, domainJwt: string) {
  const base = gaupaHost.replace(/\/$/, '');
  const res = await workerFetch(`${base}/me/challenge`, {
    headers: {
      Authorization: domainJwt,
      'public-key': publicKey,
      Accept: 'application/json',
    },
  });

  const body = (await res.json().catch(() => null)) as {
    challenge?: string;
    error?: string;
    message?: string;
  } | null;

  if (!res.ok) {
    throw new GaupaChallengeError(body?.error || body?.message || 'Challenge failed', {
      status: res.status,
    });
  }

  if (!body?.challenge) {
    throw new GaupaChallengeError('Challenge response missing challenge field', { status: res.status });
  }

  return body as { challenge: string };
}
